(async () => {
    const { Core } = await importModule('Core');
    // Icons are hosted as theme assets (fa-<name>.svg). The CDN URLs are a
    // fallback for icons picked in the theme editor that are not hosted yet.
    const LOCAL_ICONS_URL = window.theme.iconsBaseUrl;
    const CDN_ICONS_URLS = [
        "https://cdn.jsdelivr.net/gh/FortAwesome/Font-Awesome@6.x/svgs/solid/",
        "https://cdn.jsdelivr.net/gh/FortAwesome/Font-Awesome@6.x/svgs/brands/"
    ];
    const ICON_PREFIX = 'icon-';
    const CN_ICON = '#icon';

    customElements.define('load-icon', class extends Core {

        async render() {
            if (this.localIcon || await this._loadIcon()) {
                this._displayIcon()
                this._setIconProps()
                return
            }
            this._removeContainer();
        }

        async _loadIcon() {
            const urls = [];
            if (LOCAL_ICONS_URL) urls.push(`${LOCAL_ICONS_URL}fa-${this.iconName}.svg`);
            CDN_ICONS_URLS.forEach(base => urls.push(`${base}${this.iconName}.svg`));
            for (const url of urls) {
                const svg = await this._fetchIcon(url);
                if (svg) {
                    this.localIcon = svg;
                    return svg;
                }
            }
            return null;
        }

        async _fetchIcon(url) {
            try {
                const res = await fetch(url);
                if (!res.ok) throw new Error(res.status);
                const svg = await res.text();
                if (!svg.includes('<svg')) throw new Error('not an svg');
                return svg;
            } catch (error) {
                return null;
            }
        }

        _displayIcon() {
            this.innerHTML = this.localIcon;
        }

        _setIconProps() {
            const $icon = this.querySelector('svg');
            $icon.classList.add(CN_ICON);
            $icon.style.setProperty('--size', this.getAttribute('size'));
        }

        _removeContainer() {
            this.remove();
        }

        get localIcon() {
            return localStorage.getItem(this.localIconName)
        }

        set localIcon(svg) {
            return localStorage.setItem(this.localIconName, svg)
        }

        get iconName() {
            return this.getAttribute('name')
        }

        get localIconName() {
            return `${ICON_PREFIX}${this.iconName}`
        }
    })
})();
